import { DateTime } from 'luxon'

import { CHART_TYPE } from '../../../src/constants/chart-related.constant'
import { IDefaultSeries, ISankeyNode, ISankeySeries } from '../../../src/types/default-series.type'

export const pieParser = (dataList: IDefaultSeries[]) => {
  return [
    {
      type: CHART_TYPE.PIE,
      timestamp: DateTime.now().toJSDate().getTime(),
      data: dataList.map(ele => {
        // let sum = 0
        // ele.data.forEach(innerEle => {
        //   if (isNaN(Number(innerEle[ele.name])) && isNaN(Number(innerEle['value']))) {
        //     sum += 0
        //   } else {
        //     sum += Number(innerEle[ele.name] ?? innerEle['value'])
        //   }
        //   return sum
        // })
        // 24.03.13 pie차트 정책 변경
        // 기존 data의 sum에서 마지막 idx의 데이터를 표기하기로 변경
        const lastIdx = ele.data ? ele.data.length -1 : -1
        return {
          name: ele.name,
          id: ele.name,
          unit: ele.unit,
          decimalPoint: ele.decimalPoint,
          y: lastIdx > -1 ? Number(ele.data[lastIdx][ele.name] ?? ele.data[lastIdx].value ?? 0) : 0,
          visible: ele.visible ?? true,
          color: ele.color,
        }
      })
    }
  ]
}

export const sankeyParser = (dataList: IDefaultSeries[]) => {
  const nodes: ISankeyNode[] = []
  const seriesList: ISankeySeries[] = []
  dataList.forEach((ele, index) => {
    if (ele.to && ele.data.length > 0) {
      const node = {
        id: ele.name,
        name: ele.name,
        color: ele.color,
        dataLabels: index === 0 ? {
          x: 16
        } : undefined,
      }
      const series = {
        name: ele.name,
        unit: ele.unit,
        decimalPoint: ele.decimalPoint,
        color: ele.color,
        from: ele.name,
        to: ele.to,
        weight: Number(ele.data[0][ele.name] ?? ele.data[0].value ?? 0),
      }
      nodes.indexOf(node) === -1 && nodes.push(node)
      seriesList.push(series)
    }
  })
  const parseResult = [ {
    type: CHART_TYPE.SANKEY,
    nodes,
    data: seriesList,
  } ]
  return parseResult
}

export const commonParser = (dataList: IDefaultSeries[]) => {
  let zIndex = 200
  const parseResult = dataList.map(ele => {
    return {
      ...ele,
      visible: ele.visible ?? true,
      yAxis: ele.yAxis ?? 1,
      zIndex: zIndex--,
      data: ele.data.map(innerEle => {
        const dataObj = innerEle as Record<string, string | number>
        if (typeof innerEle[ele.name] === 'object' && innerEle[ele.name] !== null) {
          const namedDataObj = innerEle[ele.name] as Record<string, string | number>
          let parseObj:Record<string, string | number>

          if (ele.type === CHART_TYPE.AREA_RANGE) {
            parseObj = {
              low: Number(namedDataObj['low']),
              high: Number(namedDataObj['high']),
            }
          } else {
            parseObj = {
              ...namedDataObj,
            }
            if (!('y' in parseObj)) {
              parseObj.y = namedDataObj[ele.name] ?? namedDataObj['value'] ?? 0
            }
          }
          if ('day' in dataObj) {
            parseObj['x'] = new Date(dataObj['day']).getTime()
          }

          return parseObj
        } else {
          const parseObj:Record<string, string | number> = {
            y: Number(dataObj[ele.name] ?? dataObj['value'] ?? 0)
          }
          if ('day' in dataObj) {
            parseObj['x'] = new Date(dataObj['day']).getTime()
          }
          return parseObj

          // const parsedList: number[] = []
          // parsedList.push(Number(dataObj[ele.name] ?? dataObj['value'] ?? 0))
          // if ('day' in dataObj) {
          //   parsedList.unshift(new Date(dataObj['day']).getTime())
          // }
          //
          // return parsedList
        }
      })
    }
  })
  // console.log(parseResult)
  return parseResult
}